<template>
  <transition name="slide-fade" >

    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              If you can't come to us we will try our best to deliver our services to you.
            </p>
          </div>
        </div>
        <div class="uk-background-muted  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <!--<div class="uk-alert-primary uk-padding-small uk-margin-top uk-border-rounded"  uk-alert>

              <p class="uk-text-center">Click the degree your interested in for more information.
                <br>
                <span class="uk-text-center"><a href="#deps" class="uk-link-text uk-text-small uk-text-muted" uk-scroll="offset: 300px; duration: 2000">See abbreviations</a></span></p>
            </div>-->
            <div class="uk-padding-small uk-padding-remove-horizontal">
              <h3 style="color: rgb(197,179,88) !important;" class="uk-heading-bullet specHeading">List of Extension Campus Offerings</h3>
            </div>
            <div class="uk-overflow-auto">
              <table class="uk-table  uk-table-divider ">
                <thead>
                <tr>
                  <!-- Table header formatting -->
                  <th></th>
                  <th colspan="5" class="uk-table-shrink uk-text-center specHeading " >Degree Type <br> <span uk-icon="chevron-down"></span></th>
                  <th colspan="2" class="uk-table-shrink uk-text-center specHeading ">Classes<br> <span uk-icon="chevron-down"></span></th>
                  <th colspan="3" class="uk-table-shrink uk-text-center specHeading ">Campus<br> <span uk-icon="chevron-down"></span></th>
                </tr>
                <tr>
                  <th > </th>
                  <!-- Table headers -->
                  <th class="uk-table-shrink">A.Sc</th>
                  <th class="uk-table-shrink">B.Sc</th>
                  <th class="uk-table-shrink">B.A</th>
                  <th class="uk-table-shrink">M.A</th>
                  <th class="uk-table-shrink">Ph.D</th>
                  <th class="uk-table-shrink">Day</th>
                  <th class="uk-table-shrink">Evening</th>
                  <th class="uk-table-shrink">Eastern</th>
                  <th class="uk-table-shrink">Western</th>
                  <th class="uk-table-shrink">Online</th>
                </tr>
                </thead>
                <tbody class="">
                <tr v-for="item in loadDegrees">
                  <td>
                    <span  class="uk-margin-small-right uk-text-primary uk-text-small" >{{ item.degree_name }}</span>
                    <!--<a href="javascript:" :id="item.slug" v-on:click="findDegree" :uk-tooltip="'Learn more about a degree in ' + item.degree_name" class="uk-button-link  uk-uk-text-bold ">{{ item.degree_name }} </a>
                -->  </td>

                  <!-- <td>

                     <span  class="uk-margin-small-right uk-text-primary uk-text-small" ><i>&lt;!&ndash;{{ item.department }}&ndash;&gt;</i></span>
                   </td>-->
                  <!-- degrees-->
                  <td>
                    <span v-if="item.asc" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.ba" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.bsc" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.aa" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.phd" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <!-- Day schooling -->
                  <td class="uk-text-center">
                    <span v-if="item.day" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.evening" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <!-- Campus -->
                  <td>
                    <span v-if="item.eastern" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.western" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <!-- Online Status-->
                  <td class="uk-text-center">
                    <span v-if="item.online" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>

                </tr>


                </tbody>
              </table>
            </div>
          </div>

        </div>
        <div  id="deps" class="uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <br>
            <div v-if="imgHide">
              <img src="../assets/loading.gif" style="max-height: 220px; max-width: 220px; width: auto; height: auto;" alt="" class="uk-align-center">
            </div>
            <h3 class="uk-heading-bullet specHeading uk-margin-remove-bottom">Abbreviations</h3>
            <div class="uk-child-width-1-2@m uk-padding uk-padding-remove-vertical" uk-grid>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">Western - West Jamaica Regional </p>
                <p class="">Western - East Jamaica Regional </p>
                <p class="">Northern - North Jamaica Regional </p>

              </div>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">A.Sc - Associate of Science </p>
                <p class="">B.A - Bachelor of Arts </p>
                <p class="">B.Sc - Bachelor of Science </p>
                <p class="">M.A - Master of Arts </p>

              </div>
            </div>
            <br>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
  export default {
    name: "extensionprograms",
    data(){
      return {
        image: location.origin + '/static/logo.png',
        imgHide: true
      }
    },
    methods: {
      findDegree: function(event){
        //this.$store.commit('getArticle', (event.target.id))
        //console.log(event.target)
        //this.$router.push({ path: '/undergrad', query: { degreeName: event.target.id, degreeType: 'extensiondegrees' }})
      }
    },
    computed: {
      loadDegrees: function () {
        //this.pageLoad = true
        //console.log(this.$store.state.undergradDegrees.associate_degree)
        return this.$store.state.degree.extensionDegrees
      }
    },
    mounted(){
      window.scrollTo(0, 0);
    },
    beforeCreate(){
      this.$store.dispatch('degree/AllExtensionDegrees')
    },
    updated(){
      this.imgHide = false
    },
    metaInfo: {
      // Children can override the title.
      title: 'NCU Extension Site Degrees Offerings',
      // Result: My Page Title ← My Site
      // If a child changes the title to "My Other Page Title",
      // it will become: My Other Page Title ← My Site
      //titleTemplate: '%s ← My Site',
      // Define meta tags here.
      meta: [
        {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'description', content: 'Undergraduate Degrees offered by Northern Caribbean University '}
      ]
    }
  }
</script>

<style scoped>
  #academicsHolder{
    min-height: 75vh;
  }
  .colorIt{
    color: #333 !important;
  }
  .borderIt{
    border: #333 solid 1px !important;
  }
  .bgIt{
    background-color: #333 !important;
  }
  .whiteIt{
    color: white !important;
  }
  .smallSize{
    font-size: 10pt !important;
    padding-left: 15px;
  }
  h4, h5{
    color: silver !important;
  }
  tr > td{
    border: 1px solid #EEEEEE;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .side_borders{
    border-left: 1px solid grey;
    border-right: 1px solid grey;
  }
</style>
